<template>
    <div class="">
        <div>
            <div class="bg-gray-900">
                <!--Already Have an account Link-->
                <div class="p-4">
                    <span class="text-white text-lg select-none">Already have an account?
                        <a href="/login" class="text-blue-400 font-medium">Login Here</a>
                    </span>
                </div>

                <!--Logo & Hero Text-->
                <div class="w-full flex justify-center items-center">
                    <div class="mt-4 lg:mt-0">
                        <img class="mx-auto h-32 w-auto" src="/images/redrabbit-tile.png" alt="RedRabbit">
                        <h2 v-if="registrationForm.type == null" class="mt-4 text-center select-none text-2xl md:text-3xl leading-9 tracking-wide text-white">
                            Ready to signup?
                        </h2>
                    </div>
                </div>
                <div class="pt-4 lg:pt-6">
                    <div class="max-w-screen-xl mx-auto text-center px-6 lg:px-8">
                        <div class="max-w-3xl mx-auto space-y-2 lg:max-w-none">
                            <h1 class="text-4xl leading-9 font-extrabold text-white select-none lg:text-5xl lg:leading-none">
                                {{ registrationForm.type == null ? "Select your company type below..." : "Complete your details" }}
                            </h1>
                        </div>
                    </div>
                </div>

                <!--Registration Form-->
                <div class="mt-12 pb-16 bg-gray-100">
                    <div class="relative">
                        <div class="absolute inset-0 h-3/4 bg-gray-900"></div>
                        <div class="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-8">
                            <div class="max-w-md mx-auto space-y-4 lg:grid lg:grid-cols-2 lg:gap-5 lg:space-y-0"
                                 :class="[registrationForm.type != null ? 'max-w-lg md:max-w-2xl lg:max-w-3xl' : 'lg:max-w-5xl']">

                                <!-- Select Agency Type Card-->
                                <div v-if="registrationForm.type==null" class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                                    <div class="flex-1 p-10 bg-white border-t-4 border-brand">
                                        <div class="mt-4 flex items-baseline text-2xl select-none md:text-4xl leading-none font-extrabold text-brand">
                                            Property Agency
                                        </div>
                                        <p class="mt-5 text-lg select-none leading-7 text-gray-500">
                                            Select this option if you manage property portfolios and are looking for the best tool to manage your maintenance and
                                            inspections processes on.
                                        </p>
                                    </div>
                                    <div class="h-28 flex flex-col justify-between p-6 bg-gray-50 space-y-6">
                                        <div class="rounded-md shadow">
                                            <button @click.prevent="selectCompanyType('agency')"
                                                    class="w-full flex select-none items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring transition duration-150 ease-in-out"
                                                    aria-describedby="tier-standard">
                                                Select & Continue
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Select Contractor Type Card -->
                                <div v-if="registrationForm.type==null" class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                                    <div class="flex-1 p-10 bg-white border-t-4 border-brand">
                                        <h1 class="mt-4 flex items-baseline select-none text-2xl  md:text-4xl leading-none font-extrabold text-gray-600">
                                            Contractor
                                        </h1>
                                        <p class="mt-5 text-lg select-none leading-7 text-gray-500">
                                            Select this option if you provide maintenance or other services to property management companies who are using RedRabbit.
                                        </p>
                                    </div>
                                    <div class="h-28 flex flex-col justify-between p-6 bg-gray-50 space-y-6">
                                        <div class="rounded-md shadow">
                                            <button @click.prevent="selectCompanyType('service_provider')"
                                                    :disabled="!contractorInviteInstance"
                                                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base select-none leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring transition duration-150 ease-in-out"
                                                    aria-describedby="tier-standard"
                                                    v-text="!contractorInviteInstance ? 'Coming Soon ...' : 'Select & Continue'"
                                            ></button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Details Form -->
                                <div v-if="registrationForm.type != null" class="col-span-2 flex flex-col rounded-lg shadow-lg overflow-hidden">
                                    <div class="p-10 pb-3 bg-white border-t-4 border-brand">
                                        <div class="text-lg leading-7 text-gray-500">
                                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                                <div class="md:col-span-1">
                                                    <h3 class="text-lg font-medium leading-6 text-gray-900">User & Company Information</h3>
                                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                                        Please complete your details below so we can create a Company for you. The user details you specify here
                                                        will be for the initial account owner of this company.
                                                    </p>
                                                    <p v-if="registrationForm.type === 'agency'" class="mt-5 text-sm leading-5 text-gray-500">
                                                        Total company size is so that we can better configure RedRabbit and your training based on proven best practices
                                                        for your
                                                        company size.
                                                    </p>
                                                    <p v-else class="mt-5 text-sm leading-5 text-gray-500">
                                                        The email field cannot be edited because this is the email used to link your company to the agency's company.
                                                    </p>
                                                </div>
                                                <div class="mt-5 md:mt-0 md:col-span-2">
                                                    <div class="grid grid-cols-7 gap-6">

                                                        <div class="col-span-7">
                                                            <text-input
                                                                input-label="Company Name (CIPC)"
                                                                placeholder="Property Company (Pty) Ltd"
                                                                v-model="registrationForm.company_name"
                                                                :has-errors="registrationForm.errors.has('company_name')"
                                                            ></text-input>
                                                            <template v-slot="errorMessage">
                                                                <p v-if="registrationForm.errors.has('company_name')"
                                                                   class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("company_name") }}
                                                                </p>
                                                            </template>
                                                        </div>

                                                        <!--Company Trading Name Field-->
                                                        <div class="col-span-7" :class="[registrationForm.type !== 'agency' ? 'lg:col-span-7' :
                                                        'lg:col-span-4']">
                                                            <text-input
                                                                input-label="Trading Name"
                                                                placeholder="RentProperty Centurion"
                                                                v-model="registrationForm.trading_name"
                                                                :has-errors="registrationForm.errors.has('trading_name')"
                                                            ></text-input>
                                                            <template v-slot="errorMessage">
                                                                <p v-if="registrationForm.errors.has('trading_name')"
                                                                   class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("trading_name") }}
                                                                </p>
                                                            </template>
                                                        </div>

                                                        <!--Franchise Group Field-->
                                                        <div v-if="registrationForm.type === 'agency'" class="col-span-7 lg:col-span-3">
                                                            <label for="franchise_group"
                                                                   class="block text-sm font-medium leading-5 text-gray-700">Franchise Group</label>
                                                            <select id="franchise_group"
                                                                    v-model="registrationForm.franchise_group"
                                                                    class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out text-sm leading-5">
                                                                <option v-for="franchise in franchiseGroups" :value="franchise" :label="franchise"></option>
                                                            </select>
                                                        </div>

                                                        <!--First Name Field-->
                                                        <div class="col-span-7 lg:col-span-4">
                                                            <text-input
                                                                input-label="First Name"
                                                                placeholder="John"
                                                                v-model="registrationForm.first_name"
                                                                :has-errors="registrationForm.errors.has('first_name')"
                                                            ></text-input>
                                                            <template v-slot="errorMessage">
                                                                <p v-if="registrationForm.errors.has('first_name')"
                                                                   class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("first_name") }}
                                                                </p>
                                                            </template>
                                                        </div>

                                                        <!--Last Name Field-->
                                                        <div class="col-span-7 lg:col-span-3">
                                                            <div class="col-span-7 col-span-3">
                                                                <text-input
                                                                    input-label="Last Name"
                                                                    placeholder="Smith"
                                                                    v-model="registrationForm.last_name"
                                                                    :has-errors="registrationForm.errors.has('last_name')"
                                                                ></text-input>
                                                                <template v-slot="errorMessage">
                                                                    <p v-if="registrationForm.errors.has('last_name')"
                                                                       class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("last_name") }}
                                                                    </p>
                                                                </template>
                                                            </div>
                                                        </div>

                                                        <!--Email Field-->
                                                        <div class="col-span-7 lg:col-span-4">
                                                            <text-input
                                                                :disabled="contractorInviteInstance"
                                                                input-label="Primary Email"
                                                                type="email"
                                                                placeholder="john@example.com"
                                                                v-model="registrationForm.email"
                                                                :has-errors="registrationForm.errors.has('email')"
                                                            ></text-input>
                                                            <template v-slot="errorMessage">
                                                                <p v-if="registrationForm.errors.has('email')"
                                                                   class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("email") }}
                                                                </p>
                                                            </template>
                                                        </div>

                                                        <!--Mobile Field-->
                                                        <div class="col-span-7 lg:col-span-3">
                                                            <text-input
                                                                input-label="Mobile Number"
                                                                placeholder="0823334444"
                                                                v-model="registrationForm.mobile"
                                                                :has-errors="registrationForm.errors.has('mobile')"
                                                            ></text-input>
                                                            <template v-slot="errorMessage">
                                                                <p v-if="registrationForm.errors.has('mobile')"
                                                                   class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("mobile") }}
                                                                </p>
                                                            </template>
                                                        </div>

                                                        <!--Province Field-->
                                                        <div class="col-span-7" :class="[registrationForm.type !== 'agency' ? 'lg:col-span-3' :
                                                        'lg:col-span-4']">
                                                            <label class="block text-sm font-medium leading-5 text-gray-700">Province</label>
                                                            <select id="province"
                                                                    v-model="registrationForm.province"
                                                                    class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                                                <option v-for="province in provinces" :value="province" :label="province"></option>
                                                            </select>
                                                        </div>

                                                        <!--Password Field-->
                                                        <div class="col-span-7" :class="[registrationForm.type !== 'agency' ? 'lg:col-span-4' : 'lg:col-span-3']">
                                                            <password-field
                                                                v-model="registrationForm.password"
                                                                placeholder="Used to log in with"
                                                                :has-errors="registrationForm.errors.has('password')"
                                                            ></password-field>
                                                            <template v-slot="errorMessage">
                                                                <p v-if="registrationForm.errors.has('password')"
                                                                   class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("password") }}
                                                                </p>
                                                            </template>
                                                        </div>

                                                        <!-- Number of Employees Field-->
                                                        <div class="col-span-4" v-if="registrationForm.type === 'agency'">
                                                            <text-input
                                                                input-label="Total Company Employees (Optional)"
                                                                placeholder="5"
                                                                v-model="registrationForm.number_of_employees"
                                                                :has-errors="registrationForm.errors.has('number_of_employees')"
                                                            ></text-input>
                                                            <template v-slot="errorMessage">
                                                                <p v-if="registrationForm.errors.has('number_of_employees')"
                                                                   class="mt-1 text-xs text-red-600 leading-tight">{{ registrationForm.errors.get("number_of_employees") }}
                                                                </p>
                                                            </template>
                                                        </div>
                                                    </div>

                                                    <!--Terms Accepted Switch-->
                                                    <fieldset class="mt-6">
                                                        <div class="col-span-2">
                                                            <div class="flex items-start">
                                                                <div class="flex-shrink-0">
                                                                    <!--
                                                                      Simple toggle

                                                                      On: "bg-indigo-600", Off: "bg-gray-200"
                                                                    -->
                                                                    <span role="checkbox" tabindex="0" aria-checked="false"
                                                                          @click.prevent="registrationForm.accept_terms = !registrationForm.accept_terms"
                                                                          v-model="registrationForm.accept_terms"
                                                                          class="bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring"
                                                                          :class="[registrationForm.accept_terms === true ? 'bg-indigo-600' : 'bg-gray-200']">
                                                                        <!-- On: "translate-x-5", Off: "translate-x-0" -->
                                                                        <span aria-hidden="true"
                                                                              class="translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"
                                                                              :class="[registrationForm.accept_terms === true ? 'translate-x-5' : 'translate-x-0']"
                                                                        ></span>
                                                                    </span>
                                                                </div>
                                                                <div class="ml-3">
                                                                    <p class="text-sm leading-6 text-gray-500">
                                                                        By selecting this, you agree to our standard <br>
                                                                        <a href="https://redrabbit.zone/terms/terms-and-conditions"
                                                                           target="_blank" class="font-medium text-blue-400 underline">
                                                                            Terms & Conditions
                                                                        </a>
                                                                        &
                                                                        <a href="https://redrabbit.zone/legal/privacy-policy" target="_blank"
                                                                           class="font-medium text-blue-400 underline">
                                                                            Privacy Policy
                                                                        </a>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--Finish Registration Button-->
                                    <div class="grid grid-cols-3 gap-4 bg-gray-50 p-10">
                                        <button @click.prevent="resetRegistrationForm"
                                                class="w-full col-span-3 md:col-span-1 order-1 md:order-0 px-5 py-3 shadow border border-transparent text-gray-500 leading-6 font-medium rounded-md text-white bg-white hover:bg-gray-900 hover:text-white focus:outline-none focus:ring transition duration-150 ease-in-out"
                                                v-if="!contractorInviteInstance">
                                            Cancel
                                        </button>
                                        <button @click.prevent="register"
                                                class="w-full col-span-3 md:col-span-2 order-0 md:order-1 px-5 py-3 shadow border border-transparent text-base font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring transition duration-150 ease-in-out"
                                                :class="[!registrationFormFilled || registrationForm.busy ? 'opacity-50 cursor-not-allowed' : '',
                                                contractorInviteInstance ? 'md:col-start-2' : '']"
                                                :disabled="!registrationFormFilled || registrationForm.busy">
                                            {{ registrationForm.busy ? "Registering..." : "Finish Registration" }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Footer Text-->
            <div class="w-full text-center select-none -mt-12 p-6 text-base text-gray-400">RedRabbit Property Solutions (Pty) Ltd &middot; {{ currentYear }}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: "registration-page",
    props: ["franchiseGroups"],
    data () {
        return {
            provinces: [
                "Eastern Cape",
                "Free State",
                "Gauteng",
                "KwaZulu-Natal",
                "Limpopo",
                "Mpumalanga",
                "Northern Cape",
                "North West",
                "Western Cape",
            ],
            registrationForm: {},
            showPassword: false,
            contractorInviteInstance: false,
        };
    },

    // TODO THIS IS CURRENTLY SETTING THE CONTRACTOR BUTTON TO DISABLED AND COMING SOON FOR A COUPLE OF MONTHS,
    // TODO UNLESS YOU HAVE AN INVITE LINK
    // this.contractorInviteInstance = true;
    created () {
        this.resetRegistrationForm();

        let url = new URL(window.location.href);
        this.registrationForm.token = url.searchParams.get("token");

        // Set the form defaults when inviting a service provider
        this.registrationForm.trading_name = url.searchParams.get("service_provider_company_name");
        this.registrationForm.company_name = url.searchParams.get("service_provider_company_name");
        this.registrationForm.email = url.searchParams.get("service_provider_email");
        // Set if this instance is a contractor invite
        if (this.registrationForm.token) {
            this.contractorInviteInstance = true;
            this.registrationForm.mobile = url.searchParams.get("service_provider_mobile");
            this.registrationForm.first_name = url.searchParams.get("service_provider_first_names");
            this.registrationForm.last_name = url.searchParams.get("service_provider_last_name");
            this.registrationForm.type = url.searchParams.get("registration_type");
        }
        window.history.replaceState(null, null, window.location.pathname);
    },

    computed: {
        currentYear () {
            return (new Date()).getFullYear();
        },
        registrationFormFilled () {
            return this.registrationForm.accept_terms == true && this.registrationForm.first_name && this.registrationForm.last_name
                && this.registrationForm.email && this.registrationForm.mobile && this.registrationForm.trading_name && this.registrationForm.company_name && this.registrationForm.password;
        },
    },

    watch: {
        "registrationForm.email": function (newVal) {
            if (newVal) {
                this.registrationForm.email = newVal.replace(/[^a-zA-Z0-9_/\-@.]/g, "").toLowerCase().trim();
            }
        },

        "registrationForm.mobile": function (newVal) {
            if (newVal) {
                this.registrationForm.mobile = newVal.replace(/\D/g, "").trim();
            }
        },
    },

    methods: {
        resetRegistrationForm () {
            this.registrationForm = new AppForm({
                type: "agency",
                accept_terms: false,
                first_name: "",
                last_name: "",
                email: "",
                mobile: "",
                company_name: "",
                trading_name: "",
                province: "Western Cape",
                franchise_group: "None",
                number_of_employees: null
            });
        },
        selectCompanyType (type) {
            this.registrationForm.type = type;
        },
        register () {
            App.post("/register", this.registrationForm)
            .then((response) => {
                toastr.success(response.message);
                setTimeout(function () {
                    // If the redirect URL was set upon opening the registration page (typically when an invite)
                    // to register was sent to a service provider and we want to make the link as soon as they register
                    window.location = response.redirect_url;
                }, 1000);
            })
            .catch((error) => {
                toastr.error("Registration Failed");
            });
        },
    },
};

</script>
